(function () {
  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const withComma = `${parts[0]},${parts[1]}`;
    let value = format || '€{{amount}}';
    value = value.replace('{{amount_no_decimals}}', parts[0]);
    value = value.replace('{{amount_with_comma_separator}}', withComma);
    value = value.replace('{{amount}}', withComma);
    return value;
  }

  function renderBar(bar, totalCents) {
    const progressEl = bar.querySelector('.cart-free-shipping__progress');
    const messageEl = bar.querySelector('.cart-free-shipping__message');
    const thresholdCents = parseInt(bar.dataset.thresholdCents, 10) || 0;
    const progressTemplate = bar.dataset.progressText || '';
    const successText = bar.dataset.successText || '';
    const moneyFormat = bar.dataset.moneyFormat || '';

    const remaining = thresholdCents - totalCents;
    const percent = thresholdCents > 0 ? Math.min(100, Math.max(0, (totalCents / thresholdCents) * 100)) : 100;
    if (progressEl) progressEl.style.width = percent + '%';

    if (remaining <= 0) {
      bar.classList.add('cart-free-shipping--complete');
      if (messageEl) messageEl.textContent = successText;
    } else {
      bar.classList.remove('cart-free-shipping--complete');
      if (messageEl) messageEl.textContent = progressTemplate.replace('[[amount]]', formatMoney(remaining, moneyFormat));
    }
  }

  function refreshAllBars() {
    fetch(`${window.routes.cart_url}.json`, { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        // Query fresh here (not before the fetch): adding an item triggers a
        // synchronous cart-drawer re-render that replaces this DOM before our
        // fetch resolves, so an earlier NodeList would point at detached nodes.
        const bars = document.querySelectorAll('[data-cart-free-shipping]');
        bars.forEach((bar) => renderBar(bar, cart.total_price));
      })
      .catch(() => {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAllBars);
  }

  function init() {
    refreshAllBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:refresh-free-shipping', refreshAllBars);
})();
